// Tenant files (attachments, photos, avatars, receipts, service tickets,
// reports) are served only to time-limited links. For the file URLs this app
// builds itself, that is the file token: the server sends a fresh one with every
// API response (X-File-Token, kept by the axios instance in Services/API/api.js)
// and it is appended to the URL here. It expires on its own and when the session
// ends, so a copied link stops working. Logos and user guides are public and
// don't need it.
const STORAGE_KEY = "fileToken";

export const getFileToken = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setFileToken = (token) => {
  try {
    if (token && token !== localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, token);
    }
  } catch {
    // Storage unavailable: file links fall back to failing closed.
  }
};

export const clearFileToken = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing stored.
  }
};

export const withFileToken = (url) => {
  const token = getFileToken();
  if (!token) return url;
  return `${url}${url.includes("?") ? "&" : "?"}ft=${encodeURIComponent(token)}`;
};
